define([
    "./monitoringEditionDirective"
], function(){

});